import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface PrimXpData {
  stars: number;
  level: number;
  progress: number;
  toNext: number;
}

@Component({
  selector: 'app-prim-xp-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './prim-xp-card.component.html',
  styleUrl: './prim-xp-card.component.css',
})
export class PrimXpCardComponent {
  @Input() xp: PrimXpData = { stars: 0, level: 1, progress: 0, toNext: 100 };
}
